/*!
 * devextreme-vue
 * Version: 24.1.7
 * Build date: Wed Oct 30 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

import Draggable from "devextreme/ui/draggable";
import { createComponent } from "./core/index";
import { createConfigurationComponent } from "./core/index";
const DxDraggable = createComponent({
    props: {
        autoScroll: Boolean,
        boundary: {},
        clone: Boolean,
        container: {},
        cursorOffset: [Object, String],
        data: {},
        dragDirection: String,
        dragTemplate: {},
        elementAttr: Object,
        group: String,
        handle: String,
        height: [Function, Number, String],
        onDisposing: Function,
        onDragEnd: Function,
        onDragMove: Function,
        onDragStart: Function,
        onInitialized: Function,
        onOptionChanged: Function,
        rtlEnabled: Boolean,
        scrollSensitivity: Number,
        scrollSpeed: Number,
        width: [Function, Number, String]
    },
    emits: {
        "update:isActive": null,
        "update:hoveredElement": null,
        "update:autoScroll": null,
        "update:boundary": null,
        "update:clone": null,
        "update:container": null,
        "update:cursorOffset": null,
        "update:data": null,
        "update:dragDirection": null,
        "update:dragTemplate": null,
        "update:elementAttr": null,
        "update:group": null,
        "update:handle": null,
        "update:height": null,
        "update:onDisposing": null,
        "update:onDragEnd": null,
        "update:onDragMove": null,
        "update:onDragStart": null,
        "update:onInitialized": null,
        "update:onOptionChanged": null,
        "update:rtlEnabled": null,
        "update:scrollSensitivity": null,
        "update:scrollSpeed": null,
        "update:width": null,
    },
    computed: {
        instance() {
            return this.$_instance;
        }
    },
    beforeCreate() {
        this.$_WidgetClass = Draggable;
        this.$_hasAsyncTemplate = true;
        this.$_expectedChildren = {
            cursorOffset: { isCollectionItem: false, optionName: "cursorOffset" }
        };
    }
});
const DxCursorOffset = createConfigurationComponent({
    emits: {
        "update:isActive": null,
        "update:hoveredElement": null,
        "update:x": null,
        "update:y": null,
    },
    props: {
        x: Number,
        y: Number
    }
});
DxCursorOffset.$_optionName = "cursorOffset";
export default DxDraggable;
export { DxDraggable, DxCursorOffset };
